/* HASA theme.js — talks to Shopify's real cart endpoints (/cart/add.js, /cart.js, /cart/change.js) */
(function(){
  const money = cents => window.HASA.moneyFormat.replace('{{amount}}', (cents/100).toFixed(2).replace('.', ',')).replace('R,', 'R');

  function fmt(cents){
    // Simple ZAR formatter fallback if theme money_format isn't wired
    return 'R' + (cents/100).toLocaleString('en-ZA', {minimumFractionDigits:0, maximumFractionDigits:0});
  }

  function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.from((ctx||document).querySelectorAll(sel)); }

  /* ---------------- Toast ---------------- */
  function showToast(msg){
    const t = qs('#toast');
    if(!t) return;
    qs('#toastMsg', t).textContent = msg;
    t.classList.add('show');
    clearTimeout(window._hasaToastTimer);
    window._hasaToastTimer = setTimeout(()=>t.classList.remove('show'), 2600);
  }

  /* ---------------- Cart Drawer ---------------- */
  function openCart(){ qs('#cartDrawer').classList.add('open'); qs('#overlay').classList.add('open'); }
  function closeCart(){ qs('#cartDrawer').classList.remove('open'); qs('#overlay').classList.remove('open'); }

  function renderCartLine(item){
    return `
    <div class="cart-line" data-line-key="${item.key}">
      <div class="cart-line-media">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}</div>
      <div class="cart-line-info">
        <div class="cn">${item.product_title}</div>
        <div class="co">${item.variant_title ? 'Size: ' + item.variant_title : ''}</div>
        <div class="qty-row">
          <button type="button" data-qty-minus="${item.key}" aria-label="Decrease quantity">&minus;</button>
          <span>${item.quantity}</span>
          <button type="button" data-qty-plus="${item.key}" aria-label="Increase quantity">+</button>
          <button type="button" class="rm-line" data-remove-line="${item.key}">Remove</button>
        </div>
      </div>
    </div>`;
  }

  function refreshCart(){
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        qsa('.cart-count').forEach(el => el.textContent = cart.item_count);
        const box = qs('#drawerItems');
        if(!box) return;
        if(cart.items.length === 0){
          box.innerHTML = `<div class="empty-cart">Your bag is empty.<br><br><a href="/collections/all" class="btn small">Start shopping</a></div>`;
        } else {
          box.innerHTML = cart.items.map(renderCartLine).join('');
        }
        const subtotalEl = qs('#cartSubtotal');
        if(subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
        const checkoutBtn = qs('#checkoutBtn');
        if(checkoutBtn) checkoutBtn.disabled = cart.items.length === 0;
      })
      .catch(()=>{});
  }

  function addToCart(id, quantity){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: id, quantity: quantity || 1 }] })
    })
    .then(r => {
      if(!r.ok) return r.json().then(err => { throw err; });
      return r.json();
    });
  }

  function changeLine(key, quantity){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(r => r.json());
  }

  /* ---------------- Mobile nav ---------------- */
  function openMobileNav(){ qs('#mnav').classList.add('open'); }
  function closeMobileNav(){ qs('#mnav').classList.remove('open'); }

  /* ---------------- Header search toggle ---------------- */
  function toggleSearch(){
    const s = qs('.header-search');
    if(!s) return;
    s.classList.toggle('open');
    if(s.classList.contains('open')) qs('input', s).focus();
  }

  /* ---------------- Product page: variant / size selection ---------------- */
  function initProductForm(){
    const form = qs('[data-product-form]');
    if(!form) return;
    const variantDataEl = qs('#variantData');
    if(!variantDataEl) return;

    let variants = [];
    try{ variants = JSON.parse(variantDataEl.textContent); } catch(e){ variants = []; }

    const variantInput = qs('[name="id"]', form);
    const addBtn = qs('[data-add-to-cart]', form);
    const priceEl = qs('#pdpPrice');
    const optionGroups = qsa('[data-option-index]', form);
    const numOptions = optionGroups.length ? Math.max(...optionGroups.map(g => parseInt(g.dataset.optionIndex,10))) + 1 : 1;

    let selections = [];
    for(let i=0;i<numOptions;i++){
      const group = optionGroups.find(g => parseInt(g.dataset.optionIndex,10) === i);
      const active = group ? (qs('.opt.active', group) || qs('.opt', group)) : null;
      selections[i] = active ? active.dataset.value : null;
    }

    function findVariant(){
      return variants.find(v => {
        const opts = [v.option1, v.option2, v.option3];
        return selections.every((sel, i) => sel === null || opts[i] === sel);
      });
    }

    function money(cents){
      return 'R' + (cents/100).toLocaleString('en-ZA', {minimumFractionDigits:0, maximumFractionDigits:0});
    }

    function updateForVariant(){
      const variant = findVariant();
      if(!variant){
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      variantInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? addBtn.dataset.label : 'Sold out';
      if(priceEl){
        priceEl.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? `<span class="strike">${money(variant.compare_at_price)}</span>${money(variant.price)}`
          : money(variant.price);
      }
      optionGroups.forEach(group => {
        const idx = parseInt(group.dataset.optionIndex, 10);
        qsa('.opt', group).forEach(btn => {
          const trial = selections.slice();
          trial[idx] = btn.dataset.value;
          const match = variants.find(v => {
            const opts = [v.option1, v.option2, v.option3];
            return trial.every((sel, i) => sel === null || opts[i] === sel);
          });
          btn.classList.toggle('unavailable', !(match && match.available));
        });
      });
    }

    optionGroups.forEach(group => {
      const idx = parseInt(group.dataset.optionIndex, 10);
      qsa('.opt', group).forEach(btn => {
        btn.addEventListener('click', () => {
          qsa('.opt', group).forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          selections[idx] = btn.dataset.value;
          updateForVariant();
        });
      });
    });

    updateForVariant();

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(addBtn.disabled) return;
      const originalLabel = addBtn.dataset.label;
      addBtn.textContent = 'Adding…';
      addToCart(variantInput.value, 1)
        .then(item => {
          addBtn.textContent = originalLabel;
          refreshCart();
          showToast(`${item.product_title} added to bag`);
          openCart();
        })
        .catch(err => {
          addBtn.textContent = originalLabel;
          showToast(err.description || 'Could not add that item — please try again.');
        });
    });
  }

  /* ---------------- Quick add (collection / home grid cards) ---------------- */
  function initQuickAdd(){
    document.addEventListener('click', function(e){
      const btn = e.target.closest('[data-quickadd]');
      if(!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const id = btn.dataset.quickadd;
      const name = btn.dataset.quickaddName || 'Item';
      btn.textContent = 'Adding…';
      addToCart(id, 1)
        .then(() => {
          refreshCart();
          showToast(`${name} added to bag`);
          openCart();
          btn.textContent = 'Quick add';
        })
        .catch(err => {
          btn.textContent = 'Quick add';
          showToast(err.description || 'That option is sold out.');
        });
    });
  }

  /* ---------------- Cart drawer line qty / remove ---------------- */
  function initCartDrawerEvents(){
    document.addEventListener('click', function(e){
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');
      const remove = e.target.closest('[data-remove-line]');
      if(!minus && !plus && !remove) return;

      const line = e.target.closest('.cart-line');
      const key = line.dataset.lineKey;
      const qtySpan = qs('.qty-row span', line);
      let qty = parseInt(qtySpan.textContent, 10);

      if(minus){ qty = Math.max(0, qty - 1); }
      if(plus){ qty = qty + 1; }
      if(remove){ qty = 0; }

      changeLine(key, qty).then(refreshCart);
    });
  }

  /* ---------------- Accordion ---------------- */
  function initAccordions(){
    document.addEventListener('click', function(e){
      const head = e.target.closest('.acc-head');
      if(!head) return;
      const item = head.closest('.acc-item');
      const wasOpen = item.classList.contains('open');
      qsa('.acc-item', item.parentElement).forEach(a => a.classList.remove('open'));
      if(!wasOpen) item.classList.add('open');
    });
  }

  /* ---------------- Global click handlers ---------------- */
  function initGlobal(){
    document.addEventListener('click', function(e){
      if(e.target.id === 'cartBtn' || e.target.closest('#cartBtn')){ e.preventDefault(); openCart(); }
      if(e.target.id === 'drawerClose' || e.target.closest('#drawerClose')){ closeCart(); }
      if(e.target.id === 'overlay'){ closeCart(); closeMobileNav(); }
      if(e.target.id === 'mnavOpen' || e.target.closest('#mnavOpen')){ openMobileNav(); }
      if(e.target.id === 'mnavClose' || e.target.closest('#mnavClose')){ closeMobileNav(); }
      if(e.target.id === 'searchToggle' || e.target.closest('#searchToggle')){ toggleSearch(); }
    });

    const nform = qs('#nform');
    if(nform){
      nform.addEventListener('submit', function(e){
        // If a real Shopify customer/contact form is wired via action, let it submit.
        // Otherwise show inline confirmation for storefronts without a newsletter app yet.
        if(nform.dataset.native === 'true') return;
        e.preventDefault();
        qs('#nformMsg').textContent = "You're on the list — welcome to HASA.";
        nform.reset();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    window.HASA = window.HASA || { moneyFormat: 'R{{amount}}' };
    refreshCart();
    initProductForm();
    initQuickAdd();
    initCartDrawerEvents();
    initAccordions();
    initGlobal();
  });
})();
